import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectOptionsSearch',
})
export class TsSelectOptionsSearchPipe implements PipeTransform {
  transform(items: Array<any>, searchTxt: string): Array<any> {
    if (!items || !items.length) return items;
    if (!searchTxt || !searchTxt.length) return items;
    const q = searchTxt.toLowerCase();
    return items.filter((item) => {
      if (item === null || item === undefined) return false;
      if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
        return String(item).toLowerCase().includes(q);
      }
      const candidate = item.label ?? item.name ?? item.full_name ?? item.title ?? item.value ?? item.id ?? '';
      return String(candidate).toLowerCase().includes(q);
    });
  }
}
